import { Box } from "@mui/material";

function NotFoundPage(){
    return(
        <Box height='100vh' textAlign='center' mx='auto' my='auto' display='flex' justifyContent='center' alignItems='center'>
            Page not found...
        </Box>
    )
}

export default NotFoundPage;
